export class Applicant {
  firstName: string;
  lastName: string;
  applicantMail: string;
  applicantAbout: string;
  applicantLinkedIn: string;

  constructor(data?: any) {
    data = data || data.id;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.applicantMail = data.applicantMail;
    this.applicantAbout = data.applicantAbout;
    this.applicantLinkedIn = data.applicantLinkedIn;
  }
}
